// Define the types for each frequency's specific rules
const handleE = (object) => {
    if (object.specificDayOfMonth && object.specificWeekdays)
        throw new Error('Cannot use both (filters.daysOfMonth)BYDAY and (filters.daysOfWeek)BYMONTHDAY in the same rule.');
    if (object.specificDayOfMonth && object.specificWeekdays)
        throw new Error('Cannot use both (filters.daysOfMonth)BYDAY and (filters.daysOfWeek)BYMONTHDAY in the same rule.');
};
import { z } from 'zod';
export const FrequencySchema = z.enum([
    'SECONDLY',
    'MINUTELY',
    'HOURLY',
    'DAILY',
    'WEEKLY',
    'MONTHLY',
    'YEARLY',
]);
export const BaseRRuleSchema = z.object({
    freq: FrequencySchema,
    repeatEveryX: z.number().optional(),
    maxOccurances: z.number().optional(),
    until: z.date().optional(),
});
export const SecondlyRuleSchema = BaseRRuleSchema.extend({
    freq: z.literal('SECONDLY'),
    bysecond: z.array(z.number()).optional(),
});
export const MinutelyRuleSchema = BaseRRuleSchema.extend({
    freq: z.literal('MINUTELY'),
    bysecond: z.array(z.number()).optional(),
    byminute: z.array(z.number()).optional(),
});
export const HourlyRuleSchema = BaseRRuleSchema.extend({
    freq: z.literal('HOURLY'),
    bysecond: z.array(z.number()).optional(),
    byminute: z.array(z.number()).optional(),
    byhour: z.array(z.number()).optional(),
});
export const DailyRuleSchema = BaseRRuleSchema.extend({
    freq: z.literal('DAILY'),
    bysecond: z.array(z.number()).optional(),
    byminute: z.array(z.number()).optional(),
    byhour: z.array(z.number()).optional(),
});
export const WeeklyRuleSchema = BaseRRuleSchema.extend({
    freq: z.literal('WEEKLY'),
    specificWeekdays: z.array(z.number()).optional(),
});
export const MonthlyRuleSchema = BaseRRuleSchema.extend({
    freq: z.literal('MONTHLY'),
    specificWeekday: z.number().optional(),
    specificWeekOfMonth: z.number().optional(),
    specificDayOfMonth: z.number().optional(),
});
export const YearlyRuleSchema = BaseRRuleSchema.extend({
    freq: z.literal('YEARLY'),
    specificWeekday: z.number().optional(),
    specificWeekOfMonth: z.number().optional(),
    specificMonthOfYear: z.number().optional(),
    specificDayOfMonth: z.number().optional(),
});
export const RRuleSchema = z.union([
    SecondlyRuleSchema,
    MinutelyRuleSchema,
    HourlyRuleSchema,
    DailyRuleSchema,
    WeeklyRuleSchema,
    MonthlyRuleSchema,
    YearlyRuleSchema,
]);
export const RepeatOptionsSchema = z
    .object({
    rdates: z.array(z.date()),
    exdates: z.array(z.date()),
    rrule: RRuleSchema,
})
    .partial();
//# sourceMappingURL=rrule.types.js.map